const MoveEvent = function(battleState, actorId) {
  this.eventHandle = 'move_event';
  this.movement = true;
  this.actorId = actorId;

  this.execute = (victim) => {
    const actor = battleState.allPieces[actorId];
    if (!actor) {
      return;
    }
    this.victimId = victim.uid;
    var oldTile = battleState.getTileAtCoords(actor.x, actor.y);
    if (!oldTile) {
      return;
    }

    this.oldTileId = oldTile.uid;

    oldTile.occupied = false;

    actor.x = victim.x;
    actor.y = victim.y;

    victim.occupied = true;

    this.affectedPieces = [actor, victim, oldTile];
    battleState.onBattleEvent(this);
  };
};
module.exports = MoveEvent;
